<template>
  <div class="docs">
    <div class="top d-flex justify-content-between align-items-center">
      <transition name="slide-fade">
        <h1 class="mb-0" v-if="showTitle">{{msg}}</h1>
      </transition>
      <ul class="mb-0">
        <li class="list-inline-item">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-upload"
            round
            v-b-modal.nuevoDocumentoModal
          >Nuevo documento</el-button>
        </li>
      </ul>
    </div>

    <div class="filtro mt-3 bg-light p-3">
      <div class="row">
        <div class="col-md-4">
          <h3 class>Título</h3>
          <div class>
            <input type="text" placeholder="Título" class="form-control" v-model="title">
            <small class="form-text text-primary" v-if="helpTitle" v-html="helpTitle"></small>
          </div>
        </div>
        <div class="col-md-4">
          <h3 class>Categoría</h3>
          <div class>
            <input type="text" placeholder="Categoría" class="form-control" v-model="category">
            <small class="form-text text-primary" v-if="helpCategory" v-html="helpCategory"></small>
          </div>
        </div>
        <div class="col-md-4">
          <h3 class>Etiqueta</h3>
          <div class>
            <input type="text" placeholder="Etiqueta" class="form-control" v-model="tag">
            <small class="form-text text-primary" v-if="helpTag" v-html="helpTag"></small>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-8">
          <h3 class>Autor</h3>
          <el-select
            v-model="author"
            clearable
            filterable
            reserve-keyword
            placeholder="Autor"
            v-loading="loadingAuthors"
            class="w-100"
          >
            <el-option v-for="item in authors" :key="item.id" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </div>
        <div class="col-md-4">
          <h3 class>Año</h3>
          <el-slider
            v-model="year"
            show-input
            @change="convertYear"
            input-size="medium"
            :min="fechaMin"
            :max="ahora"
          ></el-slider>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between mt-3">
      <p class="lead mb-0">
        Total documentos:
        <strong>{{ Math.floor(totalResultsTween) }}</strong>
      </p>
      <el-button
        type="primary"
        size="medium"
        plain
        icon="el-icon-delete"
        @click="clearFilters"
      >Limpiar filtros</el-button>
    </div>

    <div class="table-responsive mt-3" v-if="docs.length >= 1">
      <table class="table table-striped table-hover table-bordered" v-loading="loadingDocuments">
        <thead class="thead-dark">
          <tr>
            <th @click="documentFilter('title')">
              Título
              <i
                class="fa float-right fa-sort"
                :class="{'fa-sort-up': sortDir == 'asc' && currentField == 'title', 'fa-sort-down': sortDir == 'desc' && currentField == 'title'}"
              ></i>
            </th>
            <th @click="documentFilter('date')">
              Fecha
              <i
                class="fa float-right fa-sort"
                :class="{'fa-sort-up': sortDir == 'asc' && currentField == 'date', 'fa-sort-down': sortDir == 'desc' && currentField == 'date'}"
              ></i>
            </th>
            <th @click="documentFilter('type')">
              Categoría
              <i
                class="fa float-right fa-sort"
                :class="{'fa-sort-up': sortDir == 'asc' && currentField == 'type', 'fa-sort-down': sortDir == 'desc' && currentField == 'type'}"
              ></i>
            </th>
            <th>Etiquetas</th>
            <th @click="documentFilter('author')">
              Autor
              <i
                class="fa float-right fa-sort"
                :class="{'fa-sort-up': sortDir == 'asc' && currentField == 'author', 'fa-sort-down': sortDir == 'desc' && currentField == 'author'}"
              ></i>
            </th>
            <th>Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="doc in docs">
            <td>{{doc.title}}</td>
            <td class="nowrap">{{doc.date/1000 | moment('DD/MM/YYYY')}}</td>
            <td>
              <el-tag type="success" size="mini" class v-if="doc.type!=''">{{doc.type}}</el-tag>
            </td>
            <td>
              <el-tag size="mini" class v-if="doc.tag1!=''">{{doc.tag1}}</el-tag>
              <el-tag type="info" size="mini" class="ml-1" v-if="doc.tag2!=''">{{doc.tag2}}</el-tag>
              <el-tag type="success" size="mini" class="ml-1" v-if="doc.tag3!=''">{{doc.tag3}}</el-tag>
            </td>
            <td>{{doc.author}}</td>
            <td class="nowrap">
              <a :href="doc.path" target="_blank" class title="Descargar">
                <el-button type="success" size="mini" icon="el-icon-download"></el-button>
              </a>
              <span class title="Borrar" @click="deleteModal(doc.id, doc.title)">
                <el-button type="danger" size="mini" icon="el-icon-delete"></el-button>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center">
        <el-pagination
          v-if="totalPages > 1"
          @current-change="documentFilter()"
          layout="prev, pager, next"
          :page-size="perPage"
          :current-page.sync="currentPage"
          :total="totalResults"
        ></el-pagination>
      </div>
    </div>
    <el-alert v-else class="mt-3" title="Sin resultados" type="success" show-icon></el-alert>

    <b-modal
      ref="nuevoDocumentoModalRef"
      id="nuevoDocumentoModal"
      title="Subir nuevo documento"
      @ok="uploadDocument($event)"
    >
      <form @submit.prevent="showModal = false">
        <el-form ref="form" :model="subirForm" label-width="90px">
          <el-form-item label="Título*">
            <el-input v-model="subirForm.title" required placeholder="Introduzca el título"></el-input>
          </el-form-item>
          <el-form-item label="Autor*">
            <el-select
              v-model="subirForm.author"
              required
              clearable
              filterable
              reserve-keyword
              placeholder="Autor"
              v-loading="loadingAuthors"
            >
              <el-option
                v-for="item in authors"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Fecha">
            <el-date-picker
              v-model="subirForm.date"
              class="w-100"
              type="date"
              placeholder="Seleccione fecha"
              :picker-options="opcionesFecha"
              format="dd-MM-yyyy"
              value-format="dd-MM-yyyy"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="Categoría*">
            <el-input v-model="subirForm.tipo" required placeholder="Introduzca la categoría"></el-input>
          </el-form-item>
          <el-form-item label="Etiqueta 1">
            <el-input v-model="subirForm.tag1" placeholder="Introduzca una etiqueta"></el-input>
          </el-form-item>
          <el-form-item label="Etiqueta 2">
            <el-input v-model="subirForm.tag2" placeholder="Introduzca una etiqueta"></el-input>
          </el-form-item>
          <el-form-item label="Etiqueta 3">
            <el-input v-model="subirForm.tag3" placeholder="Introduzca una etiqueta"></el-input>
          </el-form-item>
        </el-form>
        <file-select v-model="subirForm.file"></file-select>
      </form>
    </b-modal>
    <b-modal
      ref="deleteModalRef"
      id="promptModal"
      title="Borrar documento"
      @ok="deleteDocument(IdDeleted)"
    >
      <form @submit.prevent="showModal = false">
        <p>¿Está seguro que desea borrar el documento?</p>
        <el-alert class :closable="false" :title="this.titleDeleted" type="info"></el-alert>
      </form>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import FileSelect from "./FileSelect";
import axios from "axios";
import { APIENDPOINT } from "@/backend";
import VueMixinTween from "vue-mixin-tween";

export default {
  name: "Documents",
  components: {
    FileSelect
  },
  data() {
    return {
      payload: this.$store.getters.payload,
      showTitle: false,
      loadingAuthors: false,
      loadingDocuments: false,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      fechaMin: 1966,
      ahora: this.$moment().format("YYYY"),
      subirForm: {
        title: "",
        author: "",
        tipo: "",
        date: ""
      },
      startTime: {
        time: ""
      },
      endtime: {
        time: ""
      },
      currentPage: 1,
      perPage: 60,
      totalResults: "",
      totalResultsTween: "",
      totalPages: 0,
      file: null,
      msg: "Documentos",
      datos: [],
      docs: [],
      titleDeleted: "",
      sortDir: "desc",
      currentField: "id",
      category: "",
      helpCategory: "",
      tag: "",
      helpTag: "",
      title: "",
      helpTitle: "",
      author: "",
      authors: [],
      year: "",
      fromDate: "",
      toDate: "",
      resultados: false,
      attemptSubmit: false,
      opcionesFecha: {
        firstDayOfWeek: 1
      }
    };
  },
  watch: {
    title: function() {
      this.documentFilter();
    },
    category: function() {
      this.documentFilter();
    },
    tag: function() {
      this.documentFilter();
    },
    author: function() {
      this.documentFilter();
    }
  },

  created: function() {
    // console.log(this.payload);
    this.getAuthors();
    this.documentFilter();
  },

  mounted() {
    this.showTitle = true;
  },

  mixins: [VueMixinTween("totalResults", 1000, pos => pos)],

  methods: {
    esperaFiltra: _.debounce(function() {
      this.documentFilter();
    }, 400),

    getAuthors() {
      // console.log("getAuthors");
      this.loadingAuthors = true;
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "get",
        url: "/api/v1/documents/authors"
      })
        .then(response => {
          this.loadingAuthors = false;
          this.authors = response.data.data.authors;
        })
        .catch(e => {
          this.errors.push(e);
        });
    },

    uploadDocument: function(event) {
      // event.preventDefault()
      // console.log("uploadDocument");
      this.attemptSubmit = true;
      if (this.missingTitle || this.missingAuthor || this.missingTipo)
        return false;
      const fileData = new FormData();
      var fecha = this.subirForm.date
        .split("-")
        .reverse()
        .join("/");
      fileData.append("file", this.subirForm.file);
      fileData.append("title", this.subirForm.title);
      fileData.append("author", this.subirForm.author);
      fileData.append("date", fecha);
      fileData.append("type", this.subirForm.tipo);
      if (typeof this.subirForm.tag1 !== "undefined") {
        fileData.append("tag1", this.subirForm.tag1);
      }
      if (typeof this.subirForm.tag2 !== "undefined") {
        fileData.append("tag2", this.subirForm.tag2);
      }
      if (typeof this.subirForm.tag3 !== "undefined") {
        fileData.append("tag3", this.subirForm.tag3);
      }
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
          "Content-Type": "multipart/form-data"
        },
        method: "post",
        url: "/api/v1/documents",
        data: fileData
      })
        .then(response => {
          // console.log(response);
          this.$refs.nuevoDocumentoModalRef.hide();
          this.documentFilter();
        })
        .catch(e => {
          this.errors.push(e);
        });
    },

    documentFilter(field) {
      // console.log("documentFilter");
      if (
        (field === "type" && this.currentField === "type") ||
        (field === "title" && this.currentField === "title") ||
        (field === "date" && this.currentField === "date") ||
        (field === "author" && this.currentField === "author")
      ) {
        if (this.sortDir === "asc") {
          this.sortDir = "desc";
        } else {
          this.sortDir = "asc";
        }
      }
      if (field !== "" && typeof field !== "undefined") {
        this.currentField = field;
      }

      this.loadingDocuments = true;
      axios({
        baseURL: APIENDPOINT,
        method: "get",
        url: "/api/v1/documents",
        params: {
          sort: this.currentField,
          sortDir: this.sortDir,
          title: this.title,
          author: this.author,
          fromDate: this.fromDate,
          toDate: this.toDate,
          type: this.category,
          tag: this.tag,
          pageSize: null,
          page: this.currentPage - 1 // ñapa-jaime (cuyos libros empiezan por la pagina 0)
        }
      })
        .then(response => {
          this.loadingDocuments = false;
          this.docs = response.data.data.documentList;
          this.totalResults = response.data.data.totalResults;
          this.perPage = response.data.data.pageSize;
          this.totalPages = response.data.data.totalPages;
        })
        .catch(e => {
          this.errors.push(e);
        });
    },

    deleteModal(id, title) {
      this.IdDeleted = id;
      this.titleDeleted = title;
      this.$refs.deleteModalRef.show();
    },

    deleteDocument(id) {
      console.log("deleteDocument");
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "delete",
        url: "/api/v1/documents",
        params: { id: id }
      })
        .then(response => {
          console.log(response);
          this.documentFilter();
        })
        .catch(e => {
          this.errors.push(e);
        });
    },

    sortBy: function(sortKey) {
      this.reverse = this.sortKey === sortKey ? !this.reverse : false;
      this.sortKey = sortKey;
    },

    subirDoc: function(event) {
      event.preventDefault();
    },

    onSubmit() {
      console.log("submit!");
    },

    convertYear() {
      this.fromDate = this.year + "/01/01";
      this.toDate = this.year + "/12/31";
      console.log(this.fromDate + " - " + this.toDate);
      this.esperaFiltra();
    },

    clearFilters() {
      console.log("clearFilters");
      this.title = "";
      this.category = "";
      this.tag = "";
      this.author = "";
      this.fromDate = "";
      this.toDate = "";
      this.documentFilter();
      this.year = this.fechaMin;
    }
  },

  computed: {
    missingTitle: function() {
      return this.subirForm.title === "";
    },
    missingAuthor: function() {
      return this.subirForm.author === "";
    },
    missingTipo: function() {
      return this.subirForm.tipo === "";
    }
  }
};
</script>

<style lang="scss">
.cov-picker-box .checked {
  background-color: #31022a !important;
}

.el-slider__bar {
  background-color: #964b8a !important;
}

.el-slider__button {
  border: 2px solid #964b8a !important;
}

.el-input-number__decrease:hover,
.el-input-number__increase:hover {
  color: #964b8a;
}

.el-input-number__decrease:hover:not(.is-disabled)
  ~ .el-input
  .el-input__inner:not(.is-disabled),
.el-input-number__increase:hover:not(.is-disabled)
  ~ .el-input
  .el-input__inner:not(.is-disabled) {
  border-color: #964b8a;
}

.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #964b8a;
}

.thead-dark th {
  cursor: pointer;
}
</style>
